import { useEffect, useState } from "react";
import { StickyNote } from "lucide-react";

export default function DesktopNotification({ onOpenNotes }) {
  const [phase, setPhase] = useState("hidden"); // hidden -> in -> out
  useEffect(() => {
    const t1 = setTimeout(() => setPhase("in"), 1800);
    const t2 = setTimeout(() => setPhase("out"), 9000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);
  if (phase === "hidden") return null;
  return (
    <button
      data-testid="desktop-note-notification"
      onClick={onOpenNotes}
      className="fixed top-10 right-4 z-[85] flex items-start gap-3 w-[330px] p-3 rounded-2xl bg-white/85 border border-black/10 text-left shadow-xl"
      style={{
        backdropFilter: "blur(20px)",
        transform: phase === "in" ? "translateX(0)" : "translateX(120%)",
        opacity: phase === "in" ? 1 : 0,
        transition: "transform 550ms cubic-bezier(0.2,1,0.3,1), opacity 400ms ease",
      }}
    >
      <div className="w-9 h-9 rounded-lg bg-yellow-100 flex items-center justify-center shrink-0">
        <StickyNote size={18} className="text-yellow-600" />
      </div>
      <div className="min-w-0">
        <div className="text-[13px] font-semibold text-gray-800">Notes</div>
        <div className="text-[13px] text-gray-600">Leave Cory a note — say hi, share a win, or drop a testimonial.</div>
      </div>
    </button>
  );
}
